import React, { useEffect, useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import * as svg from '@progress/kendo-svg-icons';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { useNavigate, useParams } from 'react-router-dom';
import EmailForm from './EmailForm';
import { isMobile } from 'react-device-detect';
import { UserApi } from '../../../../../../redux/api/UserApi';
import ConfirmClose from './ConfirmClose';

const EmailModal: React.FC = () => {
    const { ticketId } = useParams();
    const navigate = useNavigate();
    const [confirmCloseVisible, setConfirmCloseVisible] = useState(false);
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        setConfirmCloseVisible(true);
        //navigate(-1);
    }

    const goBack = () => {

        navigate('/ticket/' + ticketId);
    }

    //when in fullscreen mode set overflow hidden on the body to prevent scrolling
    useEffect(() => {
        if (stage === 'FULLSCREEN') {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        //when the component unmounts set overflow back to auto
        return () => {
            document.body.style.overflow = 'auto';
        }
    }, [stage]);

    return (<>
        <ConfirmClose ticketId={parseInt(ticketId)} visible={confirmCloseVisible} onClose={() => setConfirmCloseVisible(false)} onDiscard={goBack} />
        <Window modal={true} className={stage === 'FULLSCREEN' ? 'cool-window email-action-window full-screen' : 'cool-window email-action-window'} minimizeButton={() => null} title={<><SvgIcon size='large' icon={svg.envelopIcon} className='mr-2' ></SvgIcon>Send Email</>} onClose={onWindowClose} initialHeight={Math.min(window.innerHeight - 200, 900)} initialWidth={Math.min(Math.min(window.innerWidth - 200, 1200), window.innerWidth)} stage={stage} onStageChange={onStageChange} >
            <div className='position-relative'>
                <EmailForm formName='email-action-form-popup' showSaveButton={false} onsubmitted={() => {
                    console.log('submitted');
                    navigate(-1);
                }} />
            </div>
            <WindowActionsBar>
                <Button form='email-action-form-popup' svgIcon={svg.paperPlaneIcon} type='submit' className='p-2' style={{ width: '100px', marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                    Send
                </Button>
                {/* Close button */}
                <Button fillMode='outline' svgIcon={svg.cancelIcon} onClick={onWindowClose} className='p-2' style={{ width: '100px', marginTop: '20px' }}>
                    Cancel     </Button>
            </WindowActionsBar>
        </Window ></>
    );
};

export default EmailModal;